import axios from 'axios';
import moment from 'moment';
import { getToken } from 'utils/crypto';
import { clearSentryUserContext } from 'utils/sentry';


let _cachedDeviceId = null;
function getDeviceId() {
    if (_cachedDeviceId) return _cachedDeviceId;
    try {
        _cachedDeviceId = localStorage.getItem('deviceId');
    } catch {
        // localStorage may be blocked in some WebViews (e.g. Instagram)
    }
    return _cachedDeviceId;
}

export const initAxiosInterceptors = () => {
    // if (baseUrl) {
    axios.interceptors.request.use((config) => {
        // Condition to check whether to modify the URL or not
        if (config?.useBaseUrl !== false) {
            config.url = `${process.env.REACT_APP_API_BASE}${config.url}`;
        }

        if (config.auth) {
            const token = getToken();
            if (!token) {
                throw new Error('token not found');
            }
            config.headers = {
                ...config.headers,
                'access-token': `${token}`,
                'user-local-time': moment().format('YYYY-MM-DD HH:mm:ss Z'),
                'device-id': `${getDeviceId() || ''}`,
            };
        }
        return config;
    });

    // Handle 401 Unauthorized error
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 401) {
                const cleanup = () => {
                    localStorage.clear();
                    sessionStorage.clear();
                    clearSentryUserContext();
                    window.location.replace('/');
                };
                axios
                    .post(`/authn/logout`, {}, { auth: true })
                    .then(cleanup)
                    .catch(cleanup);
            }
            throw new Object({
                data: error?.response?.data,
                status: error?.response?.status,
            });
        }
    );
    // }
};
